import styled from 'styled-components';

export const TakePhotoContainer = styled.div`
    max-width: 800px;
    width: 100%;
    max-height: 476px;
    min-height: 400px;
    border-radius: 16px;
    display: flex;
    text-align: center;
    flex-direction: column;
    gap: 20px;
    position: relative;
    margin: auto;

    &.take-address-container {
        max-height: 650px;

        .corner-line {
            & > div {
                width: 344px;
                height: 472px;
            }
        }
    }

    .camera-header {
        position: absolute;
        width: 100%;
        z-index: 100;
        top: 20px;
    }

    .title {
        color: ${(props) => props.theme.palette.primaryA7};

        span {
            color: ${(props) => props.theme.palette.primaryA1};
            border-bottom: 1px solid ${(props) => props.theme.palette.primaryA1};
        }
    }

    .camera-container {
        border-radius: 16px;
        position: relative;
        overflow: hidden;
        width: 100%;
        max-width: 1200px;
        height: 716px;
    }

    video {
        width: 100%;
        height: 100%;
        position: absolute;
        left: 50%;
        margin-left: -50%;
        object-fit: cover;
        object-position: center;
    }

    .camera-preview {
        width: 100%;
        height: 100%;
        position: absolute;
        left: 50%;
        margin-left: -50%;
        object-fit: cover;
        object-position: center;
    }

    .document-photo-img {
        width: 100%;
        max-height: 320px;
        object-fit: cover;
        box-sizing: border-box;
    }

    .camera-actions {
        position: absolute;
        bottom: 20px;
        width: 100%;
        margin: 0 auto;
        display: flex;
        justify-content: center;
        gap: 16px;

        .secondary-button {
            background-color: ${(props) => props.theme.palette.primaryA7};
            color: ${(props) => props.theme.palette.primaryA1};

            &:hover {
                background-color: ${(props) => props.theme.palette.primaryA1};
                color: ${(props) => props.theme.palette.primaryA7};
            }
        }
    }

    .spinner {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }

    .close-icon {
        position: absolute;
        right: -40px;
        top: 0;
    }

    .corner-line {
        & > div {
            width: 540px;
            height: 312px;
        }
    }
`;
